export default __webpack_public_path__ + "static/media/bgbg1.14fd7e3d.png";